



























import { Component, PropSync } from 'vue-property-decorator'
import { Action } from "vuex-class";
import { SelectWings, ToggleWings, InputWings } from 'wings-ui-components';

import { SystemSettingFilter, SystemSettingFilterImpl } from '@/store/settings/system_settings/types';
import BaseFilter from '@/components/Filter/BaseFilter';
import { notifyError } from '@/utils/notify-helper';
import axios from 'axios';
import { getTranslatedParams } from '@/utils/notify-utils';
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class SystemSettingsFilter extends BaseFilter<SystemSettingFilter> {

  @PropSync("show") is_show!: boolean;

  @Action("getSystemSettings") actionGetSystemSettings: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): SystemSettingFilter {
    return new SystemSettingFilterImpl();
  }

  async created() {
    try {
      await this.filtered();
    } catch (err) {
      notifyError(err);
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "System setting",
        addititional_info: getTranslatedParams(this.filter)
      }
      await this.actionGetSystemSettings(this.filter);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

}
